import script from "./base-task.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-task.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__